interface HeaderButtonProps {
  icon: React.ReactNode;
  label: string;
}

export function HeaderButton({ icon, label }: HeaderButtonProps) {
  return (
    <div className="bg-white box-border flex items-center justify-center gap-[4px] pl-[8px] pr-[12px] py-1 rounded-[3px]">
      <div className="overflow-clip relative shrink-0 size-[24px]">{icon}</div>
      <p
        className="font-medium leading-[20px] text-foreground text-[14px] text-nowrap whitespace-pre"
        style={{ 
          fontFamily: "var(--font-family-noto), sans-serif", 
          fontVariationSettings: "'CTGR' 0, 'wdth' 100" 
        }}
      >
        {label}
      </p>
    </div>
  );
}
